import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function SnapPixelTracker() {
    const location = useLocation();
    useEffect(() => {
        if (typeof window.snaptr !== "undefined") {
            window.snaptr("track", "PAGE_VIEW");
        }
    }, [location.pathname]);
    return null;
}
